export const WindowEvents = {
    RESIZE: "resize",
};
